module.exports = __webpack_public_path__ + "img/assa-logo.695a0a0f.svg";